import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/stores/index.js';
import VueResource from 'vue-resource';
import './registerServiceWorker'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faPlus, faDownload, faEnvelope, faEye, faChevronLeft, faChevronRight, faSave, faStar, faDog, faMotorcycle, faCar, faInfoCircle, faTruck, faBus, faTrashAlt, faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { faCopy as farCopy, faStar as farStar, faComments as farComments } from '@fortawesome/free-regular-svg-icons'
import { faInstagram, faLinkedin, faFacebook, faGoogle, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

library.add(faPlus, faDownload, faEnvelope, faEye, faChevronLeft, faChevronRight, faSave, faStar, faDog, faMotorcycle, faCar, faInfoCircle, faTruck, faBus, faTrashAlt, faFileInvoice)
library.add(farCopy, farStar, farComments)
library.add(faInstagram, faLinkedin, faFacebook, faGoogle, faWhatsapp);
Vue.component('font-awesome-icon', (resolve) => { resolve(FontAwesomeIcon) });

Vue.config.productionTip = false

Vue.use(VueResource);

new Vue({
  router,
  store,
  created() {
    Vue.http.interceptors.push((request, next) => {
      next((res) => {
        if(res.status === 401)
          this.$store.dispatch('AUTH_LOGOUT').then(() => {
            this.$router.push({ name: 'Login'})
          });
      });
    });

    Vue.http.options.root = process.env.VUE_APP_API_URL;
    const token = localStorage.getItem("token");
    if (token) {
      Vue.http.headers.common['Authorization'] = 'Bearer ' + token
    }
    
    let _log = console.log,
        _warn = console.warn,
        _error = console.error;

    console.error = function() {
      let args = '';
        for(let i = 0; i < arguments.length; i++)
        {
          args += arguments[i] + ';';
        }
      Vue.http.post('api/ConsoleLog', { type: 'error', page: window.location.href, message: args });
      return _error.apply(console, arguments);
    };

    console.warn = function() {
      let args = '';
        for(let i = 0; i < arguments.length; i++)
        {
          args += arguments[i] + ';';
        }
      Vue.http.post('api/ConsoleLog', { type: 'warn', page: window.location.href, message: args });
      return _warn.apply(console, arguments);
    };
  },
  render: h => h(App)
}).$mount('#app')
